var _path, _path2, _path3;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgMastercard(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 35,
    height: 24,
    viewBox: "0 0 35 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M17.7499 17.1569C16.5584 18.1851 15.0127 18.8058 13.3238 18.8058C9.55511 18.8058 6.5 15.7153 6.5 11.9028C6.5 8.09043 9.55511 4.99985 13.3238 4.99985C15.0127 4.99985 16.5584 5.62057 17.7499 6.6488C18.9415 5.62057 20.4871 4.99985 22.1761 4.99985C25.9448 4.99985 28.9999 8.09043 28.9999 11.9028C28.9999 15.7153 25.9448 18.8058 22.1761 18.8058C20.4871 18.8058 18.9415 18.1851 17.7499 17.1569Z",
    fill: "#ED0006"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M17.75 17.1569C19.2173 15.8908 20.1477 14.0067 20.1477 11.9028C20.1477 9.79898 19.2173 7.91495 17.7501 6.64881C18.9416 5.62061 20.4872 4.99991 22.1762 4.99991C25.9448 4.99991 28.9999 8.09049 28.9999 11.9029C28.9999 15.7153 25.9448 18.8059 22.1762 18.8059C20.4872 18.8059 18.9416 18.1852 17.75 17.1569Z",
    fill: "#F9A000"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M17.7503 17.1566C19.2175 15.8905 20.1478 14.0065 20.1478 11.9027C20.1478 9.79884 19.2175 7.91485 17.7503 6.64871C16.2831 7.91485 15.3528 9.79884 15.3528 11.9027C15.3528 14.0065 16.2831 15.8905 17.7503 17.1566Z",
    fill: "#FF5E00"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMastercard);
export default __webpack_public_path__ + "static/media/Mastercard.7d49618ba84c0cb40a901cfba62f3764.svg";
export { ForwardRef as ReactComponent };